import React, { useState, useContext } from 'react';
import {
    Switch,
    Route,
    useRouteMatch,
    Redirect
} from "react-router-dom";
import { useHistory } from 'react-router';

import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import useWindowDimensions from './useWindowDimensions';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import { CustomListItem, LkTitle, RegOfficeContacts } from './Lk.style';
import MedicineSnake from '../../assets/allIcons/MedicineSnake';
import { grey, red } from '../../assets/ui/colors';

import DoctorsContainer from '../Doctors/DoctorsContainer';
import ClinicsContainer from '../Clinics/ClinicsContainer';
import ScheduleContainer from '../Schedule/ScheduleContainer';
import AppointmentsContainer from '../Appointments/AppointmentsContainer';
import MedcardContainer from '../Medcard/MedcardContainer';
import DirectionContainer from '../Direction/DirectionContainer';
import FinishContainer from '../Finish/FinishContainer';
import FooterContainer from '../Footer/FooterContainer';
import CheckIcon from '../../assets/allIcons/CheckIcon';
import TypeOfServeceContainer from '../TypeOfServce/TypeOfServiceContainer';

import UserContext from '../../UserContext';
import MainLogo from '../../assets/allIcons/MainLogo';
import ReferralContainer from '../Referral/ReferralContainer';
import SupportContainer from '../Support/SupportContainer';
import SupportIcon from '../../assets/allIcons/SupportIcon';

const drawerWidth = 256;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: 'none',
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        position: 'fixed',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingLeft: 16,
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: '17px',
        letterSpacing: '1.25px',
        color: grey,
        whiteSpace: 'pre-wrap',
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    toolbarImg: {
        display: 'inherit',
        marginRight: 8,
        marginLeft: 12,
        marginTop: 22,
    },
    toolbarButton: {
        paddingTop: 3,
        paddingRight: 0,
        paddingLeft: 0,
    },
    content: {
        // position: 'relative',
        // height: '100vh',
        flexGrow: 1,
        padding: theme.spacing(3),
        paddingBottom: '88px',
        paddingTop: '32px',
    },
    toolbarItem: {
        width: 'auto',
        margin: 8,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '17px',
        display: 'flex',
        letterSpacing: '0.1px',
    },
    toolbarItemText: {
        fontSize: 14,
        fontWeight: 'bold',
    },
    logoutButton: {
        display: 'flex',
        color: red,
    },
    anchorEl: {
        marginLeft: 'auto',
    },
}));

const LeftDrawer = ({
    logout,
    user,
    currentMenuItem,
}) => {
    const history = useHistory();

    const classes = useStyles();
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(false);
    const openAnchorEl = Boolean(anchorEl);

    const {
        openLeftMenu, setOpenLeftMenu
    } = useContext(UserContext);

    const { path, url } = useRouteMatch();
    const currentWidth = useWindowDimensions().width;

    const handleDrawerOpen = () => {
        setOpenLeftMenu(true);
    };

    const handleDrawerClose = () => {
        setOpenLeftMenu(false);
    };

    const handleClickMenuItem = (link) => {
        if (currentWidth < 600) {
            setOpenLeftMenu(false);
        }
        history.push(link);
    }

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: openLeftMenu,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: openLeftMenu,
                        })}
                    >
                        <MenuIcon />
                    </IconButton>
                    <LkTitle>
                        Личный кабинет пациента
                    </LkTitle>
                    <LkTitle className={classes.anchorEl}>
                        {useWindowDimensions().width > 500 && user && `${user.lastName} ${user.firstName != undefined ? user.firstName[0] : ''}. ${user.middleName != undefined ? user.middleName[0] : ''}`}
                    </LkTitle>
                    <div >
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={openAnchorEl}
                            onClose={handleClose}
                        >
                            <MenuItem>
                                {user && `${user.lastName} ${user.firstName ? user.firstName : ""} ${user.middleName ? user.middleName : ""}`}
                            </MenuItem>
                            <MenuItem onClick={logout}>
                                <div className={classes.logoutButton}><ExitToAppIcon /></div>Выйти
                            </MenuItem>
                        </Menu>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="left"
                open={openLeftMenu}
                variant={useWindowDimensions().width > 500 ? "permanent" : "persistent"}
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: openLeftMenu,
                    [classes.drawerClose]: !openLeftMenu,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: openLeftMenu,
                        [classes.drawerClose]: !openLeftMenu,
                    }),
                }}
                style={useWindowDimensions().width > 500 ? { position: 'inherit' } : { position: 'absolute' }}
            >
                <div className={classes.toolbar}>
                    <div className={classes.toolbarImg}><MainLogo /></div>
                    <IconButton onClick={handleDrawerClose} className={classes.toolbarButton}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton>
                </div>
                <List>
                    <div onClick={() => handleClickMenuItem(`${url}`)} to={`${url}`}>
                        <CustomListItem
                            button
                            className={classes.toolbarItem}
                            isactive={
                              !currentMenuItem.includes('appointments')
                              && !currentMenuItem.includes('medcard')
                              && !currentMenuItem.includes('support')
                            }
                        >
                            <ListItemIcon>{<AccessTimeIcon />}</ListItemIcon>
                            <span className={classes.toolbarItemText}>Запись на прием</span>
                        </CustomListItem>
                    </div>
                    <div onClick={() => handleClickMenuItem(`${url}/appointments`)} to={`${url}/appointments`}>
                        <CustomListItem
                            button
                            className={classes.toolbarItem}
                            isactive={currentMenuItem.includes('appointments')}
                        >
                            <ListItemIcon>{<CalendarTodayIcon />}</ListItemIcon>
                            <span className={classes.toolbarItemText}>Мои приемы</span>
                        </CustomListItem>
                    </div>
                    <div onClick={() => handleClickMenuItem(`${url}/medcard`)} to={`${url}/medcard`}>
                        <CustomListItem
                            button
                            className={classes.toolbarItem}
                            isactive={currentMenuItem.includes('medcard')}
                        >
                            <ListItemIcon>{<AssignmentIcon />}</ListItemIcon>
                            <span className={classes.toolbarItemText}>Медкарта</span>
                        </CustomListItem>
                    </div>
                    <div onClick={() => handleClickMenuItem(`${url}/support`)} to={`${url}/support`}>
                        <CustomListItem
                            button
                            className={classes.toolbarItem}
                            isactive={currentMenuItem.includes('support')}
                        >
                            <ListItemIcon>{<SupportIcon />}</ListItemIcon>
                            <span className={classes.toolbarItemText}>Техподдержка</span>
                        </CustomListItem>
                    </div>
                </List>
                {/* <RegOfficeContacts>
                    Регистратура: <a href="tel:84212452636">8 (4212) 45-26-36</a>
                </RegOfficeContacts> */}

            </Drawer>

            <main className={classes.content}>
                <div className={classes.toolbar} />
                <Switch>
                    <Route exact path={path}>
                        <Redirect to={`${path}/clinics`} />
                    </Route>
                    <Route path={`${path}/clinics`}>
                        <ClinicsContainer />
                        <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                        />
                    </Route>
                    <Route path={`${path}/referral/:clinicId/:buildingId`}>
                        <ReferralContainer />
                        <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                        />
                    </Route>
                    <Route path={`${path}/service/:clinicId/:buildingId/:isReferral`}>
                        <TypeOfServeceContainer />
                        <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                        />
                    </Route>
                    <Route path={`${path}/doctors/:clinicId/:buildingId/:serviceId/:serviceName/:isReferral`}>
                        <DoctorsContainer />
                        <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                        />
                    </Route>
                    <Route path={`${path}/direct/:clinicId/:buildingId/:specialisationId/:cabinetId/:doctor/:categoryType/:isReferral/:typeServices`}>
                        <DirectionContainer />
                        <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                        />
                    </Route>
                    <Route path={`${path}/schedule/:clinicId/:specializationId/:cabinetId/:doctor/:categoryType/:buildingId/:typeServices`}>
                        <ScheduleContainer />
                        <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                        />
                    </Route>
                    <Route path={`${path}/finish/:typeServices`}>
                        <FinishContainer />
                        {/* <FooterContainer
                            leftMargin={openLeftMenu ? drawerWidth : 0}
                            nextBtnText="Подтверждаю"
                            nextBtnIcon={<CheckIcon />}
                            isNextBtnDisabled
                        /> */}
                    </Route>
                    <Route path={`${path}/appointments`}>
                        <AppointmentsContainer />
                    </Route>
                    <Route path={`${path}/medcard`}>
                        <MedcardContainer />
                    </Route>
                    <Route path={`${path}/support`}>
                        <SupportContainer />
                    </Route>
                </Switch>
            </main>

        </div >
    );
}

export default LeftDrawer;
